"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RiseupAccount = exports.RiseupMarket = exports.ProductsWithAccountId = exports.Products = exports.RiseupProduct = exports.RiseupAccountId = void 0;
const z = require("zod");
const UtilTypes_1 = require("./UtilTypes");
exports.RiseupAccountId = UtilTypes_1.NumberString;
exports.RiseupProduct = z.enum(['cashflow', 'saving', 'challenges']);
exports.Products = z.object({
    [exports.RiseupProduct.enum.cashflow]: z.boolean(),
    [exports.RiseupProduct.enum.saving]: z.boolean(),
    [exports.RiseupProduct.enum.challenges]: z.boolean(),
});
exports.ProductsWithAccountId = z.object({
    products: exports.Products,
    id: exports.RiseupAccountId,
});
exports.RiseupMarket = z.enum(['IL', 'UK']);
exports.RiseupAccount = z.object({
    id: exports.RiseupAccountId,
    created: UtilTypes_1.DateString,
    products: exports.Products,
    market: exports.RiseupMarket,
});
//# sourceMappingURL=RiseupAccount.js.map